import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import * as types from './types';
export default _defineProperty({}, types.SET_ORDER_FORM_ID, function (state, payload) {
  state.orderFormId = payload;
});